// extracted by mini-css-extract-plugin
export default {"container":"QuestionList_container__SpR8I","title":"QuestionList_title__8YBxS"};